import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface ReviewPictureSizeType {
	height: number;
	link: string;
	link_with_play_button: string;
	width: number;
}

interface ReviewPicturesType {
	base_link: string;
	player_embed_url: string;
	width: number;
	height: number;
	sizes: ReviewPictureSizeType[];
}

/** ```
 * 리뷰 사진 조회
 *   `/api/bff/vimeo/videos/${vimeoId}`
 * parameter
 *   `vimeoId
 * ```*/
const key = `useReviewSummary`;
const getPath = (vimeoId?: string): string | null => {
	if (!vimeoId) return "";
	return `${publicRuntimeConfig.ENV_SUPPORT_URL}/api/bff/vimeo/videos/${vimeoId}`;
};

/** ```
 * 리뷰 사진 조회
 *   `/api/bff/vimeo/videos/${vimeoId}`
 * parameter
 *   `vimeoId
 * ```*/
const useReviewPictures = (vimeoId?: string, options?: Partial<UseQueryOptions<Response<ReviewPicturesType>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(vimeoId)],
		queryFn: () => useConfigureAxios({url: getPath(vimeoId)}).then(r => r.data),
		gcTime: 1000 * 60 * 30,
		staleTime: 1000 * 60 * 30,
		throwOnError: false,
		...options,
	});

export default useReviewPictures;
export {getPath, key};
export type {ReviewPicturesType, ReviewPictureSizeType};
